import CELL_DATA_TYPES from '../cell-types.config';

// Channels module configurations
export const LISTING_COLUMNS = [
  {
    id: 'email',
    label: 'Email',
    width: '12%',
    align: 'left',
    dataKey: 'email',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'firstName',
    label: 'First Name',
    width: '8%',
    align: 'center',
    dataKey: 'firstName',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'lastName',
    label: 'Last Name',
    width: '8%',
    align: 'center',
    dataKey: 'lastName',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'ip',
    label: 'IP Address / Device UID',
    width: '15%',
    align: 'left',
    dataKey: 'ip',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
    secondaryFields: [
      {
        dataKey: 'deviceUid',
        type: CELL_DATA_TYPES.TEXT,
      },
    ],
  },
  {
    id: 'countryName',
    label: 'Location Info',
    width: '15%',
    align: 'left',
    dataKey: 'countryName',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
    secondaryFields: [
      {
        dataKey: 'regionName',
        type: CELL_DATA_TYPES.TEXT,
      },
    ],
  },
  {
    id: 'status',
    label: 'Status',
    width: '10%',
    align: 'center',
    dataKey: 'status',
    sortable: true,
    type: CELL_DATA_TYPES.CONTACT_STATUS,
  },
  {
    id: 'createdAt',
    label: 'Created Date',
    width: '12%',
    align: 'right',
    dataKey: 'createdAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'modifiedAt',
    label: 'Modified Date',
    width: '12%',
    align: 'right',
    dataKey: 'modifiedAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [];
